'use strict';

const maxSmallId = 4839182330;
const maxLargeId = 1389952941817855;
const evenCharacters = 'PqnpRxJrdsGL0fCYlHcTzh6Q9WwZbtV2MBg8D71jmk3Fy4N5SvXK';
const oddCharacters = 'RNkbH49BwyYDF2VzvcQsL7r1MJ3xnTPtGd6S0lmKWpCX8g5qZjfh';
const endCharacters = 'DUTMXGQBPNLFWERHAKZCVYJIOS';
const alphas = 'qwertyuadfghxcvb';
const decoder = [0, 8, 6, 4, 2, 7, 5, 3, 1];

// prettier-ignore
const evenCharactersReverse = [
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, 12, 38,
  31, 42, 45, 47, 22, 37, 35, 24, -1, -1,
  -1, -1, -1, -1, -1, -1, 33, 14, 36, -1,
  43, 10, 17, -1, 6, 51, 11, 32, 46, -1,
  0, 23, 4, 48, 19, -1, 30, 25, 50, 15,
  27, -1, -1, -1, -1, -1, -1, -1, 28, 18,
  8, -1, 13, 34, 21, -1, 39, 41, 16, 40,
  2, -1, 3, 1, 7, 9, 29, -1, 49, 26,
  5, 44, 20,
];

// prettier-ignore
const oddCharactersReverse = [
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, 36, 23,
  13, 26, 5, 46, 34, 21, 44, 6, -1, -1,
  -1, -1, -1, -1, -1, -1, 7, 42, 11, -1,
  12, 32, 4, -1, 25, 39, 20, 24, 1, -1,
  30, 18, 0, 35, 29, -1, 14, 40, 43, 10,
  48, -1, -1, -1, -1, -1, -1, -1, 3, 17,
  33, -1, 50, 45, 51, -1, 49, 2, 37, 38,
  28, -1, 41, 47, 22, 19, 31, -1, 16, 8,
  27, 9, 15,
];

// prettier-ignore
const endCharactersReverse = [
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, 16, 7, 19, 0, 13,
  11, 5, 15, 23, 22, 17, 10, 3, 9, 24,
  8, 6, 14, 25, 2, 1, 20, 12, 4, 21,
  18, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1,
];

// prettier-ignore
const alphasReverse = [
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, 7, 15, 13,
  8, 2, 9, 10, 11, -1, -1, -1, -1, -1,
  -1, -1, -1, 0, 3, -1, 4, 6, 14, 1,
  12, 5,
];

const charactersReverse = [
  endCharactersReverse,
  oddCharactersReverse,
  evenCharactersReverse,
  oddCharactersReverse,
  evenCharactersReverse,
  oddCharactersReverse,
  evenCharactersReverse,
  oddCharactersReverse,
  evenCharactersReverse,
];

function encryptSmallId(id) {
  const nibbles = [];
  let _id = id;
  let trailer = 0;
  let encryptedId = '';

  while (_id > 0) {
    nibbles.push(_id & 15);
    _id = Math.floor(_id / 16);
  }

  for (let i = 0; i < nibbles.length; i += 2) {
    encryptedId += alphas[nibbles[i]];
  }

  for (let i = nibbles.length - 1 - (nibbles.length % 2); i > 0; i -= 2) {
    trailer <<= 4;
    trailer |= nibbles[i];
  }

  return encryptedId + trailer;
}

function encryptLargeId(id) {
  const encryptedId = [];
  let _id = id;
  let remainder;

  for (let i = 0; i < 8; i++) {
    const _i = i < 4 ? i * 2 + 1 : (i - 3) * 2;

    remainder = _id % 52;
    _id = Math.floor(_id / 52);

    encryptedId[_i] =
      i % 2 === 0 ? evenCharacters[remainder] : oddCharacters[remainder];
  }

  return endCharacters[_id] + encryptedId.join('');
}

function decryptSmallId(id) {
  if (!/^[qwertyuadfghxcvb]+[0-9]+$/.test(id)) return 0;

  const nibbles = [];
  let decryptedId = 0;

  for (let i = 0; i < id.length; i++) {
    if (/^[0-9]$/.test(id[i])) break;

    nibbles[i * 2] = alphasReverse[id.charCodeAt(i)];
  }

  let trailer = Number(id.match(/\d+/)[0]);

  for (let i = 1; trailer > 0; i += 2) {
    nibbles[i] = trailer & 15;
    trailer >>= 4;
  }

  for (let i = nibbles.length - 1; i >= 0; i--) {
    decryptedId *= 16;
    decryptedId += nibbles[i] | 0;
  }

  return decryptedId;
}

function decryptLargeId(id) {
  if (!/^[a-z][0-9bcdfghjklmnpqrstvwxyz]{8}$/i.test(id)) return 0;

  let decryptedId = 0;

  for (let i = 0; i < id.length; i++) {
    decryptedId *= 52;
    decryptedId += charactersReverse[i][id[decoder[i]].charCodeAt()];
  }

  return decryptedId;
}

exports.encryptShipmentId = (id) => {
  if (id < 1 || id > maxLargeId) return null;

  return id <= maxSmallId ? encryptSmallId(id) : encryptLargeId(id);
};

exports.decryptShipmentId = (id) => {
  if (id == null) return 0;

  return /^[a-z]$/.test(id[0]) ? decryptSmallId(id) : decryptLargeId(id);
};
